var _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTestes(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "testes",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 171 171",
    style: {
      enableBackground: "new 0 0 171 171"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#DD5100;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "testes_1_"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M74,106.8h13.9v8.2H74V106.8z M58.6,105.8c-2.8,0-5.1,2.3-5.1,5.1c0,2.8,2.3,5.1,5.1,5.1s5.1-2.3,5.1-5.1 C63.8,108.1,61.5,105.8,58.6,105.8z M115.4,80.8H74V89h41.4V80.8z M58.6,79.7c-2.8,0-5.1,2.3-5.1,5.1s2.3,5.1,5.1,5.1 s5.1-2.3,5.1-5.1S61.5,79.7,58.6,79.7z M115.4,56.2H74v8.2h41.4V56.2z M58.6,55.1c-2.8,0-5.1,2.3-5.1,5.1c0,2.8,2.3,5.1,5.1,5.1 s5.1-2.3,5.1-5.1C63.8,57.4,61.5,55.1,58.6,55.1z M41.2,125.7V45.3c0-2.3,1.8-4.1,4.1-4.1h80.4c2.3,0,4.1,1.8,4.1,4.1v46.3h8.2 V45.3c0-6.8-5.5-12.3-12.3-12.3H45.3C38.5,33,33,38.5,33,45.3v80.4c0,6.8,5.5,12.3,12.3,12.3h47.4v-8.2H45.3 C43,129.8,41.2,127.9,41.2,125.7z M132.2,138l-8.2-8.2c-2.8,1.7-6,2.6-9.4,2.6c-10.2,0-18.5-8.3-18.5-18.5s8.3-18.5,18.5-18.5 s18.5,8.3,18.5,18.5c0,3.8-1.1,7.3-3.1,10.2l8,8L132.2,138z M114.6,124.2c5.7,0,10.3-4.6,10.3-10.3c0-5.7-4.6-10.3-10.3-10.3 c-5.7,0-10.3,4.6-10.3,10.3C104.3,119.6,108.9,124.2,114.6,124.2z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTestes);
export default __webpack_public_path__ + "static/media/testes.d8af10bcc82f763bee50f05d99e48c59.svg";
export { ForwardRef as ReactComponent };